import React from 'react';
import { education } from '../data/content';

export default function Education() {
  return (
    <section className="education" id="education">
      <p className="section-title">Education</p>
      <div className="education__header">
        {education.logo && (
          <div className="education__logo-wrap">
            <img
              src={process.env.PUBLIC_URL + education.logo}
              alt=""
              className="education__logo"
            />
          </div>
        )}
        <div>
          <h2>{education.school}</h2>
          <p className="education__degree">{education.degree}</p>
          <p className="education__honour">{education.honour}</p>
        </div>
      </div>
    </section>
  );
}
